import type * as Core from 'app/core/models/essette-api';
import { createCacheToken } from 'app/shared/lib/cache/create-cache-token';
import { createSimpleCache, CreateSimpleCacheOptions } from 'app/shared/lib/cache/create-simple-cache';
import { Sorting } from 'app/shared/lib/essette-site';

export interface INotesCacheState {
    notes: ReadonlyArray<Core.Note>;
    sorting?: Sorting;
    resultCount?: number;
    page?: number;
    targetId?: string;
    includeInactive?: boolean;
}

export const createNotesCache = (opts: CreateSimpleCacheOptions<INotesCacheState>) => createSimpleCache<INotesCacheState>({ notes: [] }, opts);

export const NotesCache = createCacheToken<INotesCacheState>('NOTES_CACHE', createNotesCache);

export type INotesCache = ReturnType<typeof createNotesCache>;
